import React from 'react'
import { Grid } from 'util/ui'

const OverviewRow = ({ children, columns = 4 }) => {
  return <Grid.Row columns={columns}>{children}</Grid.Row>
}

export default OverviewRow
